import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search-small",
  "use": "search-small-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"search-small\"><title>search-small</title><g id=\"search-small__visibility\"><g id=\"search-small_Layer_6-2\" data-name=\"Layer 6\"><path d=\"M18.853,18.1521l-5.57-5.57a7,7,0,1,0-.71.71l5.57,5.57a.502.502,0,0,0,.71-.71ZM2.003,8.0021a6,6,0,1,1,6,6A6,6,0,0,1,2.003,8.0021Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search-small.svg
// module id = qM9u
// module chunks = 4